// extracted by mini-css-extract-plugin
module.exports = {"card":"accountLinkCard_card__1RDFs","header":"accountLinkCard_header__3CFXB","stack":"accountLinkCard_stack__3P34I","body":"accountLinkCard_body__2_5a4"};